import styled from "@emotion/styled";
import { motion } from "framer-motion";

export const AnimatedLight = styled(motion.img)`
  position: absolute;
  mix-blend-mode: screen;
  z-index: 10;
`;
